import { render, staticRenderFns } from "./AutomovilOvp.vue?vue&type=template&id=24e89b5d&scoped=true"
import script from "./AutomovilOvp.vue?vue&type=script&lang=ts"
export * from "./AutomovilOvp.vue?vue&type=script&lang=ts"
import style0 from "./AutomovilOvp.vue?vue&type=style&index=0&id=24e89b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e89b5d",
  null
  
)

export default component.exports